module.exports = __webpack_public_path__ + "static/media/email.46d3e703.svg";